export const en = {
    meta: {
        description: "Only 199 individually numbered bikes worldwide. Meet the S-Works Tarmac SL9 LTD Built for Legends: hand-finished Race Red paint, custom SRAM RED AXS, 6.6 kg and the lowest Time to Finish Specialized has ever measured.",
        ogLocale: "en_US",
        notFound: {
            title: "Page not found",
            eyebrow: "Error 404",
            heading: "This page dropped off the back.",
            body: "The page you are looking for does not exist or has moved.",
            cta: "Back to the bike"
        },
        serverError: {
            title: "Something went wrong",
            eyebrow: "Error 500",
            heading: "We had a mechanical.",
            body: "Something went wrong on our side. Please try again in a moment.",
            cta: "Back to the bike"
        }
    },
    nav: {
        links: [
            { href: '/#story', label: "Story" },
            { href: '/#craft', label: "Craft" },
            { href: '/#racing', label: "Racing" },
            { href: '/#time-to-finish', label: "Technology" },
            { href: '/#specs', label: "Specs" },
            { href: '/#geometry', label: "Geometry" },
            { href: '/configurator', label: "C72 Configurator" }
        ],
        cta: "Register interest",
        openMenu: "Open menu",
        closeMenu: "Close menu",
        language: "Language",
        primary: "Primary",
        skip: "Skip to content"
    },
    hero: {
        eyebrow: "Limited edition · 199 numbered bikes worldwide",
        titleSmall: "S-Works Tarmac SL9 LTD",
        titleLarge: "Built for Legends",
        lead: "One bike to rule them all. A celebration of the Tarmac's winning legacy, finished by hand in Race Red.",
        priceLabel: "Price",
        colorLabel: "Color",
        colorValue: "Race Red",
        sizesLabel: "Sizes",
        ctaPrimary: "Register interest",
        ctaSecondary: "Explore the bike",
        imageAlt: "S-Works Tarmac SL9 LTD Built for Legends in Race Red, side view"
    },
    stats: [
        { value: "199", unit: "", label: "Individually numbered bikes worldwide" },
        { value: "687", unit: "g", label: "FACT 12r carbon frame, size 56" },
        { value: "6.6", unit: "kg", label: "Complete bike, size 56" },
        { value: "4", unit: "W", label: "Less drag than the SL8 at 45 km/h" }
    ],
    ticker: ["Built for Legends", "199 numbered bikes", "One bike to rule them all", "Made in Racing Red", "Time to Finish"],
    story: {
        eyebrow: "One bike to rule them all",
        title: "The fastest road bike Specialized has ever made.",
        paragraphs: [
            "The all-new S-Works Tarmac SL9 is the fastest road bike Specialized has ever built. Not only because it is light, not only because it is the most aerodynamic Tarmac yet, and not only because of the way it handles, but because it delivers the lowest real-world Time to Finish of any road bike Specialized has tested.",
            "The Built for Legends LTD honors the Tarmac's unmatched record of winning with an exclusive finish, a custom blacked-out SRAM RED AXS groupset with red brake calipers, and details drawn from the most decorated race bike in the sport. Only 199 individually numbered bikes will be made. Once they are gone, they are gone for good.",
            "Proven on real courses, real terrain and under real riders, the SL9 turns more of your effort into pure speed. When the goal is to cross the line first, no road bike gets you there faster."
        ],
        glance: {
            title: "At a glance",
            rows: [
                { label: "Use", value: "Road racing" },
                { label: "Exclusive LTD edition", value: "Only 199 individually numbered bikes" },
                { label: "Frame", value: "FACT 12r carbon, 687 g" },
                { label: "Wheels / cockpit", value: "Roval Rapide Sprint CLX and Rapide Integrated" },
                { label: "Drivetrain", value: "Custom SRAM RED AXS" },
                { label: "Weight", value: "6.6 kg" }
            ],
            link: "See full specifications"
        }
    },
    craft: {
        eyebrow: "Made in Racing Red",
        title: "A finish no two bikes share.",
        paragraphs: [
            "A red glaze is laid over a layer of silver dust, so the frame shifts from deep crimson to a glossy metallic red as the light moves across it.",
            "An ink wash is applied by hand and fades to dark along every edge. Each frame is then polished and finished by hand, which makes every one of the 199 truly one of a kind."
        ],
        caption: "Polished and finished by hand",
        mainImageAlt: "Close-up of the hand-finished Race Red paint and the numbered plaque on the seat tube",
        details: [
            { title: "One of 199", body: "A plaque on the seat tube carries each bike's sequential production number." },
            { title: "Blacked-out RED AXS", body: "A custom SRAM RED AXS groupset in black, set off by red anodized brake calipers." },
            { title: "Tan walls, carbon spokes", body: "Roval Rapide Sprint CLX wheels with composite aero spokes, wrapped in 30 mm Cotton TLR tires." }
        ],
        detailImageAlt: "View over the saddle to the cockpit, with the red front brake caliper in sight",
        detailImageCaption: "Blacked-out cockpit, red calipers"
    },
    racing: {
        eyebrow: "Made in Racing",
        title: "Proven where it counts.",
        intro: "The Built for Legends collection marks a 2026 season in which Specialized won across every discipline, with the Tarmac SL9 leading the way on the road.",
        stats: [
            { value: "4", label: "Stage wins at the Tour de France", detail: "Tim Merlier and Remco Evenepoel" },
            { value: "6/9", label: "Stages won at the Tour de France Femmes", detail: "Demi Vollering, Lorena Wiebes and Kim Le Court-Pienaar" },
            { value: "2", label: "Jerseys at the Tour de France Femmes", detail: "Yellow and green" }
        ],
        board: {
            title: "Results board",
            caption: "Tour de France Femmes 2026, raced on the Tarmac SL9",
            columns: { rider: "Rider", result: "Result", time: "Time" },
            rows: [
                { race: "Tour de France Femmes", result: "Overall winner", rider: "Demi Vollering", time: "2:44:43", timeNote: "Stage 9" },
                { race: "Tour de France Femmes", result: "Stage 6 winner", rider: "Kim Le Court-Pienaar", time: "4:01:48", timeNote: "Stage 6" }
            ]
        },
        disciplines: {
            title: "Legends in every discipline",
            items: [
                { name: "Epic 9", label: "Cross-country", result: "4 World Cup wins" },
                { name: "Demo 11", label: "Downhill", result: "4 World Cup wins" },
                { name: "Crux 5", label: "Gravel", result: "Swept the men's podium at Unbound 2026" }
            ]
        }
    },
    timeToFinish: {
        eyebrow: "Specialized Science Club presents",
        title: "Time to Finish.",
        subtitle: "The only metric that matters.",
        body: "Specialized validated the Tarmac SL9 with the most comprehensive road race simulations it has ever run. Aerodynamics, weight, rolling resistance, road surface, weather and rider power are combined into a single number: how long it takes to reach the finish on real courses, from stages of the Tour de France to Liège–Bastogne–Liège and the 2026 Montréal Worlds circuit.",
        highlights: [
            { value: "14", unit: "s", text: "If Demi Vollering had ridden the final stage of the 2024 Tour de France Femmes on a Tarmac SL9, she would have been 14 seconds faster. She lost that Tour by 4. That is the gap between regret and history." },
            { value: "28", unit: "s", text: "Saved over the Tarmac SL8 on a simulated 100 km Grand Tour stage." }
        ],
        chart: {
            title: "Simulated 100 km Grand Tour stage",
            subtitle: "Gap to the Tarmac SL9, in seconds",
            columns: { bike: "Bike", gap: "Gap", time: "Finish time" },
            fastest: "Fastest",
            unit: "s",
            note: "Size 56, all bikes with SRAM RED AXS. Source: Specialized race simulation."
        }
    },
    aero: {
        eyebrow: "Aero where it matters",
        title: "4 watts faster.",
        intro: "Measured at 45 km/h against the Tarmac SL8, with drag weighted toward the narrow wind angles of a real race: 70% of the weighting sits within ±5° and 95% within ±10°.",
        features: [
            { id: 'speed-sniffer', tag: "Head tube", title: "Speed Sniffer", body: "4 mm narrower for 10% less frontal area. A patent-pending offset steerer routes the brake hoses down one side to make room, while the upper steerer stays a standard round 1 1/8 inch." },
            { id: 'fork', tag: "Fork", title: "Sculpted fork", body: "Deeper legs twist outward to guide air around the frame, and the crown nests into the junction of the head tube and down tube." },
            { id: 'down-tube', tag: "Down tube", title: "Lowered down tube", body: "Every tube was reshaped around moving-leg wind tunnel data. The down tube now sits lower, closing the gap to the fork and front tire." },
            { id: 'win-fin', tag: "Seat tube", title: "Win Fin", body: "The seat tube reaches back to hug the rear wheel. Tuned for the one-bottle reality of breakaways and sprints, it saves 0.5 W at 45 km/h." },
            { id: 'seatpost', tag: "Seatpost", title: "Rapide seatpost", body: "The thinnest seatpost section Specialized has ever made, placed where it matters most, with compliance left unchanged." }
        ],
        imageAlt: "Front view of the narrow Speed Sniffer head tube and the Roval Rapide cockpit"
    },
    engineering: {
        eyebrow: "Unrivaled lightness",
        title: "687 grams of FACT 12r carbon.",
        body: "Four watts faster than the SL8 for just 2 extra grams. The FACT 12r frame with Flow State Design is claimed at 687 g in size 56, and the complete Built for Legends LTD weighs 6.6 kg.",
        weight: { value: "6.6", unit: "kg", label: "Complete bike, size 56" },
        points: [
            { title: "Rider-First Engineered", body: "Every size from 44 to 61 gets its own carbon layup, so every rider gets the same balance of stiffness, compliance and handling." },
            { title: "Ride quality, untouched", body: "Stiffness, compliance and handling targets match the Tarmac SL8 exactly. Every ply does double duty." },
            { title: "Moving-leg mannequin", body: "Developed in Specialized's Win Tunnel with a full-body pedaling mannequin, positioned to the millimeter by laser between every test." },
            { title: "Built for real roads", body: "Clearance for 32 mm tires, a threaded BSA bottom bracket and a UDH dropout." }
        ],
        imageAlt: "S-Works Tarmac SL9 LTD Built for Legends, front three-quarter view"
    },
    gallery: {
        eyebrow: "Every angle",
        title: "Study the details.",
        items: {
            profile: "Side profile",
            frontQuarter: "Front three-quarter",
            rearQuarter: "Rear three-quarter",
            seatTube: "Seat tube and numbered plaque",
            cockpit: "Cockpit and red calipers",
            headTube: "Speed Sniffer head tube"
        },
        previous: "Previous image",
        next: "Next image",
        thumbnails: "Choose an image"
    },
    specs: {
        eyebrow: "Technical specifications",
        title: "Every component, listed.",
        groups: [
            {
                title: "Frameset",
                rows: [
                    { label: "Frame", value: "S-Works Tarmac SL9, FACT 12r carbon, Rider-First Engineered, Win Tunnel Engineered, CeramicSpeed SLT headset bearings, threaded BB, 12x142 mm thru-axle, flat-mount disc, UDH dropout" },
                    { label: "Fork", value: "S-Works FACT 12r carbon, 12x100 mm thru-axle, flat-mount disc" },
                    { label: "Seatpost", value: "S-Works Rapide Post, FACT carbon, 15 mm offset" },
                    { label: "Seat binder", value: "Tarmac integrated wedge" }
                ]
            },
            {
                title: "Drivetrain",
                rows: [
                    { label: "Shift levers", value: "SRAM RED AXS E1, hydraulic disc" },
                    { label: "Front derailleur", value: "SRAM RED AXS E1, braze-on" },
                    { label: "Rear derailleur", value: "SRAM RED AXS E1, 12-speed" },
                    { label: "Crankset", value: "SRAM RED AXS E1 with Quarq power meter, 50/37t" },
                    { label: "Cassette", value: "SRAM RED XG-1290 E1, 12-speed, 10-36t" },
                    { label: "Chain", value: "SRAM RED E1" },
                    { label: "Bottom bracket", value: "CeramicSpeed BB Alpha, BSA DUB" }
                ]
            },
            {
                title: "Brakes",
                rows: [
                    { label: "Front brake", value: "SRAM RED E1, hydraulic disc" },
                    { label: "Rear brake", value: "SRAM RED E1, hydraulic disc" }
                ]
            },
            {
                title: "Wheels and tires",
                rows: [
                    { label: "Front wheel", value: "Roval Rapide Sprint CLX, tubeless, 21 mm internal width carbon rim, 63 mm depth, Win Tunnel Engineered, Roval LF18-F hub, 18h, Roval by ARRIS composite aero spokes with Ti end pieces" },
                    { label: "Rear wheel", value: "Roval Rapide Sprint CLX, tubeless, 21 mm internal width carbon rim, 58 mm depth, Win Tunnel Engineered, Roval LF19-R hub, 24h, Roval by ARRIS composite aero spokes with Ti end pieces" },
                    { label: "Tires", value: "Cotton TLR, 700x30, front and rear" },
                    { label: "Inner tubes", value: "700x25-35, 80 mm Presta valve, TPU" }
                ]
            },
            {
                title: "Cockpit",
                rows: [
                    { label: "Handlebar and stem", value: "Roval Rapide Cockpit, integrated bar and stem" },
                    { label: "Bar tape", value: "Supacaz Super Sticky Kush" },
                    { label: "Saddle", value: "S-Works Power with Mirror" }
                ]
            },
            {
                title: "Details",
                rows: [
                    { label: "Weight", value: "6.6 kg (14 lb 8.8 oz), size 56" },
                    { label: "Color", value: "Race Red" },
                    { label: "Sizes", value: "44, 49, 52, 54, 56, 58" },
                    { label: "Edition", value: "199 individually numbered bikes worldwide" }
                ]
            }
        ],
        note: "Specifications come from Specialized and may change without notice."
    },
    geometry: {
        eyebrow: "Geometry",
        title: "Race geometry in six sizes.",
        intro: "Identical to the S-Works Tarmac SL9 frameset. Choose a size to highlight it.",
        sizeLabel: "Size",
        highlightLabel: "Highlight a size",
        caption: "S-Works Tarmac SL9 LTD frame geometry by size",
        rows: {
            stack: "Stack",
            reach: "Reach",
            headTubeLength: "Head tube length",
            headTubeAngle: "Head tube angle",
            seatTubeAngle: "Seat tube angle",
            topTube: "Top tube length, horizontal",
            chainstay: "Chainstay length",
            bbDrop: "Bottom bracket drop",
            wheelbase: "Wheelbase",
            forkOffset: "Fork offset",
            trail: "Trail",
            standover: "Standover height"
        },
        note: "Lengths in millimeters, angles in degrees."
    },
    register: {
        eyebrow: "Only 199 will ever exist",
        title: "Register your interest.",
        body: "Leave your details and preferred size. We will contact you about availability and the next steps to secure a numbered Built for Legends LTD.",
        officialLink: "View on specialized.com",
        imageAlt: "S-Works Tarmac SL9 LTD Built for Legends, rear three-quarter view",
        form: {
            name: "Full name",
            namePlaceholder: "Your name",
            email: "Email",
            emailPlaceholder: "you@example.com",
            phone: "Phone",
            phonePlaceholder: "+886 912 345 678",
            optional: "Optional",
            size: "Preferred frame size",
            notSure: "Not sure",
            message: "Message",
            messagePlaceholder: "Your height, riding background or any questions",
            consent: "We only use your details to contact you about this bike, and we never share them.",
            submit: "Register interest",
            submitting: "Sending",
            successTitle: "You're on the list.",
            successBody: "Thank you. We have received your request and will be in touch soon.",
            again: "Send another request",
            errors: {
                name: "Please enter your name.",
                email: "Please enter a valid email address.",
                phone: "Please enter a valid phone number.",
                size: "Please choose a frame size.",
                message: "Please keep your message under 1,000 characters.",
                generic: "Something went wrong. Please try again in a moment.",
                rateLimited: "Too many requests. Please wait a few minutes and try again."
            }
        }
    },
    configurator: {
        meta: {
            title: "Colnago C72 configurator",
            description: "Configure a Colnago C72 Road: choose one of four hand-painted colorways, your frame size and a frame kit or complete build, then request a quote."
        },
        eyebrow: "Colnago C72 Road",
        title: "Configure your C72.",
        lead: "Lugged carbon, handmade in Italy and built to order. Pick a paint, a size and a build, and we will come back to you with a quote for Taiwan.",
        officialLink: "Open Colnago's official configurator",
        stageCaption: "Paint preview on the frameset",
        stageAlt: "Colnago C72 frameset in {paint}",
        stepLabel: "Step",
        steps: {
            paint: "Paint",
            size: "Frame size",
            build: "Build"
        },
        paints: {
            HFRD: { name: "Black / Red", description: "Black frame with a red top tube and seat stays." },
            HFWS: { name: "Pearl White / Silver", description: "A refined composition of pearl white and silver over black." },
            HFBK: { name: "Full Black", description: "Gloss and matte black, lifted by subtle bronze details." },
            HFTB: { name: "Dual-tone Blue", description: "Deep navy with a light blue top tube and seat stays." }
        },
        paintNote: "Every scheme draws the eye along the line where the seat stays flow into the top tube.",
        sizeUnit: "cm",
        notSure: "Not sure",
        sizeHint: "Seven sizes from 42 to 57. Not sure yet? We will help you choose.",
        builds: {
            'frame-kit': { name: "Frame kit", detail: "Frame, fork, headset and CC.02 integrated cockpit" },
            'dura-ace-sharq': { name: "Shimano Dura-Ace Di2", detail: "Fulcrum Sharq 57 wheels" },
            'dura-ace-enve': { name: "Shimano Dura-Ace Di2", detail: "Enve SES 4.5 wheels" },
            'super-record-bora': { name: "Campagnolo Super Record 13", detail: "Campagnolo Bora Ultra WTO wheels" },
            'red-axs-enve': { name: "SRAM RED AXS", detail: "Enve SES 4.5 wheels, power meter included" }
        },
        buildNote: "Gearing, crank length, bar size and saddle are confirmed with you when we prepare your quote.",
        summary: {
            title: "Your C72",
            paint: "Paint",
            size: "Size",
            build: "Build",
            notChosen: "Not chosen yet",
            price: "Price",
            priceValue: "Quoted for Taiwan",
            cta: "Request a quote",
            copyLink: "Copy link",
            copied: "Link copied"
        },
        quote: {
            eyebrow: "Request a quote",
            title: "Send us your C72.",
            body: "Every C72 is built to order in Italy, so we confirm the price, the fit and the lead time with you personally. Send this configuration with your details and we will reply with a quote.",
            configTitle: "Your configuration",
            edit: "Edit",
            name: "Full name",
            namePlaceholder: "Your name",
            email: "Email",
            emailPlaceholder: "you@example.com",
            phone: "Phone",
            phonePlaceholder: "+886 912 345 678",
            optional: "Optional",
            message: "Fit notes",
            messagePlaceholder: "Height, inseam, preferred crank length or anything else",
            consent: "We only use your details to prepare your quote, and we never share them.",
            submit: "Send quote request",
            submitting: "Sending",
            successTitle: "Quote request sent.",
            successBody: "Thank you. We have your configuration and will reply with a quote soon.",
            again: "Configure another C72",
            errors: {
                paint: "Please choose a paint.",
                size: "Please choose a frame size.",
                build: "Please choose a build.",
                name: "Please enter your name.",
                email: "Please enter a valid email address.",
                phone: "Please enter a valid phone number.",
                message: "Please keep your notes under 1,000 characters.",
                config: "Please finish your configuration above first.",
                generic: "Something went wrong. Please try again in a moment.",
                rateLimited: "Too many requests. Please wait a few minutes and try again."
            }
        },
        highlights: {
            eyebrow: "Why the C72",
            title: "Built the deliberate way.",
            intro: "In an era of monocoque frames, the C72 keeps Colnago's lugged method: tubes and lugs made first, then bonded, finished and painted by hand.",
            imageAlt: "Colnago C72 in Black / Red with SRAM RED AXS and Enve wheels, side view",
            imageCaption: "Shown: Black / Red with SRAM RED AXS and Enve SES 4.5",
            items: [
                { value: "7", label: "Carbon tubes bonded into lugs", body: "Each tube's layup is tuned on its own before the frame is assembled and hand-finished in Italy." },
                { value: "895 g", label: "Claimed frame weight", body: "Size 48.5, unpainted. 30 g lighter than the C68, though weight was never the main goal." },
                { value: "35 mm", label: "Tire clearance", body: "Designed around 30 mm tires, with room for 35 mm on 700C wheels." },
                { value: "CC.02", label: "Integrated cockpit", body: "15 g lighter than the CC.01, with less reach and more flare for control low in the drops." },
                { value: "BSA 68", label: "Threaded bottom bracket", body: "Works with Shimano, SRAM and Campagnolo groupsets." },
                { value: "3,000", label: "Frames a year", body: "Production is capped, and every bike is built to order." }
            ],
            storage: {
                title: "Hidden down tube storage",
                body: "A flush compartment whose cover doubles as the bottle cage mount, holding a mini ratchet, bits, a TPU tube and a CO2 adaptor."
            },
            legal: "Colnago and C72 are trademarks of Colnago. Product photography by Colnago."
        }
    },
    footer: {
        tagline: "One bike to rule them all. 199 numbered bikes, finished by hand in Race Red.",
        explore: "Explore",
        official: "Official product page",
        officialLink: "S-Works Tarmac SL9 LTD on specialized.com",
        legal: "Specialized, S-Works, Tarmac and Roval are trademarks of Specialized Bicycle Components, Inc. Product photography by Specialized.",
        backToTop: "Back to top"
    }
}

export type Dictionary = typeof en
